import { Progress as RadixProgress } from "radix-ui";
import { cn } from "../lib/cn";

export interface ProgressBarProps {
	/** 0–100. Игнорируется при `indeterminate`. */
	value?: number;
	indeterminate?: boolean;
	/** 4px — единственная толщина в системе; проп оставлен для мелких плашек. */
	height?: number;
	label?: string;
	className?: string;
}

/**
 * Полоса прогресса 4px: зелёная заливка на серой дорожке, ширина едет по
 * --ease-elegant. Неопределённое состояние — бегунок на треть ширины, а не
 * пульсация: пульсация читается как «сломалось».
 */
export function ProgressBar({
	value = 0,
	indeterminate = false,
	height = 4,
	label,
	className,
}: ProgressBarProps) {
	const clamped = Math.max(0, Math.min(100, value));
	return (
		<RadixProgress.Root
			value={indeterminate ? null : clamped}
			aria-label={label}
			className={cn("relative block w-full overflow-hidden rounded-full bg-sunken", className)}
			style={{ height }}
		>
			<RadixProgress.Indicator
				className="h-full rounded-full bg-brand transition-[width] duration-[var(--dur-400)] ease-elegant"
				style={
					indeterminate
						? { width: "33%", animation: "iec-bar 1.4s var(--ease-smooth) infinite" }
						: { width: `${clamped}%` }
				}
			/>
		</RadixProgress.Root>
	);
}
